import { getThemeColors } from '../../utils/chartTheme';

export const getOptions = () => {
    const tc = getThemeColors();
    return {
        maintainAspectRatio: true,
        responsive: true,
        title: {
            display: true,
            text: ''
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const val = Math.round((context.dataset.data[context.dataIndex] / 100) * 100);
                        return context.dataset.label + ': ' + val + ' kWh';
                    },
                    footer: function (tooltipItems) {
                        let total = 0;
                        tooltipItems.forEach(function(item) {
                            total += item.raw;
                        });
                        return 'Gesamt: ' + Math.round(total / 100) + ' kWh';
                    }
                }
            },
            datalabels: {
                anchor: 'top',
                color: tc.datalabelColor,
                align: 'end',
                display: true,
                formatter: function (value) {
                    return Math.round(value / 100);
                },
                font: {
                    weight: 'normal'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                grid: { color: tc.gridColor },
                ticks: {
                    autoSkip: false,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'Monat',
                    color: tc.textColor
                }
            },
            y: {
                stacked: true,
                grid: { color: tc.gridColor },
                ticks: {
                    beginAtZero: true,
                    color: tc.textColor,
                    callback: function(value) {
                        return Math.round(value / 100) + ' kWh';
                    }
                },
                title: {
                    display: true,
                    text: 'kWh',
                    color: tc.textColor
                }
            }
        }
    };
};